import React, { useEffect, useState } from 'react';
import { Bot, Workflow, Mail, FileText, PhoneCall, Database, ShoppingCart, Users2, LucideIcon } from 'lucide-react';
import '../styles/LiveActivity.css';

interface Action {
  id: number;
  icon: LucideIcon;
  agent: string;
  detail: string;
  tone: 'blue' | 'violet' | 'cyan' | 'mint' | 'amber';
}

const ACTIONS: Action[] = [
  { id: 1, icon: PhoneCall, agent: 'Voice Agent · acme.io',     detail: 'Booked 3 demos · 1 escalated',              tone: 'blue'   },
  { id: 2, icon: Workflow,  agent: 'Invoice Pipeline · luxor',  detail: '47 invoices reconciled to QuickBooks',      tone: 'violet' },
  { id: 3, icon: Mail,      agent: 'Outbound · brightline',     detail: '128 personalised emails queued',            tone: 'cyan'   },
  { id: 4, icon: FileText,  agent: 'Contract Review · Northway',detail: '12 NDAs auto-redlined',                     tone: 'mint'   },
  { id: 5, icon: Bot,       agent: 'Support Tier-1 · saasco',   detail: '312 tickets resolved · 6 escalated',        tone: 'blue'   },
  { id: 6, icon: Database,  agent: 'ELT Sync · Veridian',       detail: 'BigQuery refresh complete · 4.2M rows',     tone: 'amber'  },
  { id: 7, icon: Users2,    agent: 'Onboarding · Helix HR',     detail: 'New hire provisioned in 8 systems',         tone: 'violet' },
  { id: 8, icon: ShoppingCart, agent: 'Order Recovery · Kelpco',detail: '23 abandoned carts won back',               tone: 'mint'   },
];

const LiveActivity: React.FC = () => {
  const [tick, setTick] = useState<number>(0);

  useEffect(() => {
    const id = window.setInterval(() => setTick((t) => t + 1), 2400);
    return () => window.clearInterval(id);
  }, []);

  const visible = [
    ACTIONS[(tick + 0) % ACTIONS.length],
    ACTIONS[(tick + 1) % ACTIONS.length],
    ACTIONS[(tick + 2) % ACTIONS.length],
    ACTIONS[(tick + 3) % ACTIONS.length],
  ];

  return (
    <section className="live-activity reveal" aria-label="Recent agent activity">
      <div className="container">
        <div className="live-header">
          <span className="live-pulse">
            <span className="live-dot" />
            Live · agents in production
          </span>
          <h3>What Datryx agents did in the last hour.</h3>
        </div>

        <div className="live-feed" aria-live="polite">
          {visible.map((a, idx) => {
            const Icon = a.icon;
            return (
              <div
                key={`${a.id}-${tick}-${idx}`}
                className={`live-row tone-${a.tone}`}
                style={{ animationDelay: `${idx * 60}ms` }}
              >
                <div className="live-icon">
                  <Icon size={14} />
                </div>
                <div className="live-text">
                  <span className="live-agent">{a.agent}</span>
                  <span className="live-detail">{a.detail}</span>
                </div>
                <span className="live-time">just now</span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default LiveActivity;
